import { gql } from "@apollo/client";

export const classroomBookingChangeStatusMutation = gql`
  mutation($scenarioId: ID!, $originId: ID!, $input: ClassroomBookingChangeStatusInput) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      classroomBookingChangeStatus(input: $input) {
        skippedValidations
        commited
        bookings {
          id
          title
          description
        }
        validationErrors {
          __typename
          ... on ClassroomClash {
            sessions {
              id
            }
          }
        }
      }
    }
  }
`;
